import { WindowService } from './../../services/window.service';
import { ApiService } from './../../services/api.service';
import { BountyService } from '../../services/bounty.service';
import { Bounty } from '../../interfaces/Bounty';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { SuiModalService } from 'ng2-semantic-ui';
import { ConfirmModal } from '../confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  public fetching = true;
  public bountiesCreated: Bounty[];
  public bountiesLiked: Bounty[];
  public bountiesClaimed: Bounty[];
  public loggedInUser: any;
  public userId: string;
  public userProfile: any;
  public payments: any[] | null;
  public refunding = false;
  public refundError: string;

  constructor(
    private bountyService: BountyService,
    private userService: UserService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private windowService: WindowService,
    private modalService: SuiModalService,
  ) {
    this.loggedInUser = this.userService.getUser();
    this.userId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    // Get initial pre-rendered data from window object
    const preRenderedData = this.windowService.appData;

    if (preRenderedData) {
      const { bountiesCreated, bountiesLiked, bountiesClaimed, user, payments } = preRenderedData;
      this.bountiesCreated = bountiesCreated;
      this.bountiesLiked = bountiesLiked;
      this.bountiesClaimed = bountiesClaimed;
      this.userProfile = user;
      this.fetching = false;
      this.payments = payments;
    } else {
      this.fetchData();
    }
  }

  public async fetchData() {
    this.fetching = true;
    const {
      bountiesCreated,
      bountiesLiked,
      bountiesClaimed,
      user,
      payments,
    } = await this.bountyService.getUserProfile(this.userId);
    this.bountiesCreated = bountiesCreated;
    this.bountiesLiked = bountiesLiked;
    this.bountiesClaimed = bountiesClaimed;
    this.userProfile = user;
    this.fetching = false;
    this.payments = payments;
  }

  public async banUser() {
    await this.apiService
      .post('ban-user', { userId: this.userProfile.id })
      .toPromise();
    await this.fetchData();
  }

  public async unbanUser() {
    await this.apiService
      .post('unban-user', { userId: this.userProfile.id })
      .toPromise();
    await this.fetchData();
  }

  get isMe() {
    return (
      this.loggedInUser &&
      this.userProfile &&
      this.userProfile.id === this.loggedInUser.id
    );
  }

  public async refundPayment(payment) {
    this.modalService
    .open(
      new ConfirmModal(
        'Refund payment',
        `Are you sure you want to refund this payment?`,
      ),
    )
    .onApprove(async () => {
      this.refunding = true;
      this.refundError = undefined;

      try {
        await this.apiService.post(`refund-payment/${payment.id}`, {}).toPromise();
        await this.fetchData();
      } catch (e) {
        if (e.error && e.error.error) {
          this.refundError = e.error.error;
        } else {
          this.refundError = 'A server error occured.';
        }
      }
      this.refunding = false;
    });
  }

  public paymentStatusLabelClass(payment): string {
    switch (payment.payment_status) {
      case 'refunded': return 'orange';
      case 'approved': return 'green';
      default: return '';
    }
  }
}
